export default __webpack_public_path__ + "static/media/025.a6bb558f.jpg";